<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormFolio" role="form" method="post" autocomplete="off" onSubmit="return false">
					
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Tipo">Tipo</label>
							<input type="text" v-model="objFolio.Tipo" class="form-control" id="Tipo" placeholder="Ingresar Tipo" readonly/>
							<CValidation v-if="this.errorvalidacion.Tipo" :Mensaje="'*'+errorvalidacion.Tipo[0]"/>
						</div>
					</div>

                    <div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Serie">Serie</label>
							<input type="text" v-model="objFolio.Serie" class="form-control" id="Serie" placeholder="Ingresar Serie" :readonly="[objFolio.IdFolio == 1 ? true : false]" />
							<CValidation v-if="this.errorvalidacion.Serie" :Mensaje="'*'+errorvalidacion.Serie[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Numero">Numero</label>
							<input type="text" v-model="objFolio.Numero" class="form-control" id="Numero" placeholder="Ingresar Numero" />
							<CValidation v-if="this.errorvalidacion.Numero" :Mensaje="'*'+errorvalidacion.Numero[0]"/>
						</div>
					</div>
					
					
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormFolio',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objFolio: {
				IdFolio: 0,
				IdSucursal: '',
				Tipo: '',
				Numero: '',
				Serie: '',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objFolio.IdFolio == 0) {
				await this.$http.post(
					'Folios',this.objFolio
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'Folios/'+this.objFolio.IdFolio,
					this.objFolio
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "Folios/"+this.objFolio.IdFolio
            ).then((res) => {
                this.objFolio = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objFolio.Fecha.replace(/-/g,'\/');
                this.objFolio.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objFolio = {
				IdFolio: 0,
				IdSucursal: '',
				Tipo: '',
				Numero: '',
				Serie: '',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objFolio.IdFolio = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
